
import dataMap from '~/utils/assess.json'
export default {
  name: 'AssessScrollTab',
  components: {},
  props: {
    title: {
      type: String,
      default: '超10万模板供你选择',
    },
    // 需要获取的对象数据
    keyName: {
      type: String,
      default: 'assess',
    },
    data: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      // img: require('~/assets/image/scence/assess/background-blue.png'),
      curActive: '',
      tabs: [],
      dataList: [],
      cols: 2,
      size: 4,
    }
  },
  fetch() {
    this.tabs = (this.data || dataMap[this.keyName]).map((v) => ({ ...v, order: String(v.order) }))
    this.curActive = this?.tabs?.[0]?.order
    this.dataList = this?.tabs?.[0]?.items
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
    isPad() {
      return this.$store.state.isPad
    },
  },
  mounted() {
    this.active = this.tabs[0].name
  },
  methods: {
    handleClick(order) {
      this.dataList = this.tabs[this.curActive].items.slice(0, 8)
    },
    changeWidth({ width }) {
      if (!this.isMobile) return
      if (width - 17 >= 640) {
        this.cols = 4
        this.size = 8
      } else {
        this.cols = 2
        this.size = 4
      }
    },
  },
}
